export const module = {
  info: {
    name: 'jikatel-dialplan-manual',
    caption: 'Jikatel Dialplan Manual'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  sideMenu: {
    caption: 'Jikatel Dialplan Manual',
    icon: 'el-icon-edit-outline',
    routeName: 'module->jikatel-dialplan-manual->panel',
  }
}

export default module
